/* import __COLOCATED_TEMPLATE__ from './identity-verification-key-display.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type MessengerApiSecret from 'embercom/models/messenger-security/messenger-api-secret';

interface Args {
  keys: MessengerApiSecret[];
}

export default class IdentityVerificationKeyDisplay extends Component<Args> {
  @service declare router: RouterService;
  @service declare appService: AppService;

  get activeKeys() {
    return this.args.keys.sortBy('createdAt').reverse();
  }

  @action
  navigateToKeyManagement() {
    this.router.transitionTo('apps.app.settings.workspace.security', {
      queryParams: { tab: 'messenger-security' },
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::IdentityVerificationKeyDisplay': typeof IdentityVerificationKeyDisplay;
    'messenger-settings/security/identity-verification-key-display': typeof IdentityVerificationKeyDisplay;
  }
}
